import Image from "next/image"

import CSS from './intro-hero.module.css'

export const IntroHero = ({ hero, heroMobile }) => {
    return (
        <section className={CSS.layout}>
            <div className={CSS.mask}>
                <Image src={`/assets/theme/bokeh-mask-bottom.png`} width={1920} height={300} layout={`responsive`} />
            </div>

            <div className={CSS.mobile}>
                <Image src={heroMobile.src} width={heroMobile.width} height={heroMobile.height} layout={`responsive`} />
            </div>
            <div className={CSS.desktop}>
                <Image src={hero.src} width={hero.width} height={hero.height} layout={`responsive`} />
            </div>
        </section>
    )
}